import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { pageURLs } from "../../constants/pageURLs";
import "./DemoTemplateBanner.scss";

const DemoTemplateBanner = ({ ownerName }) => {
  const navigate = useNavigate();
  const trimmedOwner = (ownerName || "").trim();
  const ownerLabel = trimmedOwner.length > 0 ? trimmedOwner : "another agent";

  return (
    <div className="demo-template-banner mb-4">
      <h6 className="demo-template-banner__title">
        Template Want-Listing
      </h6>
      <p className="demo-template-banner__copy">
        You are viewing a sample posted by {ownerLabel} for the demo. Post your
        own Want-Listing to see Matches and Introductions for it.
      </p>
      <Button
        variant="primary"
        className="demo-template-banner__cta w-100"
        onClick={() => navigate(pageURLs.agentCreatewantad)}
      >
        Post Want-Listing
      </Button>
    </div>
  );
};

export default DemoTemplateBanner;
